// Here is where you put all feature flags
// You might not need to use these constants, especially if your code is in TS
export const OPTIMIZELY_FEATURE_EXAMPLE_FEATURE = 'example_feature';
export const OPTIMIZELY_INSTITUTION_USER_INFO = 'institution_user_info';
export const OPTIMIZELY_INSTITUTION_EXPLICIT_USER_INFO =
  'institution_explicit_user_info';
export const OPTIMIZELY_ACCREDIBLE_INTEGRATION = 'accredible_integration';
export const OPTIMIZELY_COMMUNITY_TAGS = 'community_tags';
export const OPTIMIZELY_INSTITUTION_SETTINGS_MANAGE_PEOPLE =
  'institution_settings_manage_people';
export const OPTIMIZELY_NEW_BLOCKPAGE_UI = 'new_blockpage_ui';
export const OPTIMIZELY_NEW_RICH_TEXT_RENDERER = 'new_web_rich_text_renderer';
export const OPTIMIZELY_MOBILE_NATIVE_WIDGETS = 'mobile_native_widgets';
export const OPTIMIZELY_MOBILE_NEW_KEYBOARD_ACCESSORY =
  'mobile_new_keyboard_accessory';
export const OPTIMIZELY_EZPROXY_INTEGRATION = 'ezproxy_integration';
